import {
  DocumentNode,
  LazyQueryHookOptions,
  MutationHookOptions,
  OperationVariables,
  QueryHookOptions,
  TypedDocumentNode,
  useLazyQuery,
  useMutation,
} from "@apollo/client";
import { QueryResult, useQuery } from ".";

export const ADMIN_CONTEXT = { isAdminQuery: true };

export function useAdminQuery<
  TData = unknown,
  TVariables extends OperationVariables = never,
>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: QueryHookOptions<TData, TVariables>,
): QueryResult<TData, TVariables> {
  return useQuery<TData, TVariables>(query, {
    ...options,
    context: { ...options?.context, ...ADMIN_CONTEXT },
  });
}

export function useAdminLazyQuery<
  TData = unknown,
  TVariables extends OperationVariables = never,
>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: LazyQueryHookOptions<TData, TVariables>,
) {
  return useLazyQuery<TData, TVariables>(query, {
    ...options,
    context: { ...options?.context, ...ADMIN_CONTEXT },
  });
}

export function useAdminMutation<
  TData = unknown,
  TVariables extends OperationVariables = never,
>(
  mutation: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: MutationHookOptions<TData, TVariables>,
) {
  return useMutation<TData, TVariables>(mutation, {
    ...options,
    context: { ...options?.context, ...ADMIN_CONTEXT },
  });
}
